'use client'

// src/api/queries/schedule.ts
var SCHEDULE_QUERY = `
title
openTitle
openDateTime
closeDateTime
openScheduleText
`;

export {
  SCHEDULE_QUERY
};
//# sourceMappingURL=chunk-5GNKV3HD.mjs.map